/**
 * @fileoverview Youth Academy API service for ClubOS
 */
import apiClient from "../client";

export const academyService = {
  // ── Dashboard ─────────────────────────────────────────────────────────────
  getDashboard: () => apiClient.get("/academy/dashboard"),

  // ── Age Groups ────────────────────────────────────────────────────────────
  getAgeGroups: () => apiClient.get("/academy/age-groups"),
  saveAgeGroups: (ageGroups) => apiClient.put("/academy/age-groups", { ageGroups }),

  // ── Coach Roles ──────────────────────────────────────────────���─────────────
  getCoachRoles: () => apiClient.get("/academy/coach-roles"),
  saveCoachRoles: (roles) => apiClient.put("/academy/coach-roles", { roles }),

  // ── Training Day Schedules ────────────────────────────────────────────────
  getTrainingDaySchedules: () => apiClient.get("/academy/training-day-schedules"),
  saveTrainingDaySchedules: (trainingDays) => apiClient.put("/academy/training-day-schedules", { trainingDays }),

  // ── Time Slots ────────────────────────────────────────────────────────────
  getTimeSlots: () => apiClient.get("/academy/time-slots"),
  saveTimeSlots: (timeSlots) => apiClient.put("/academy/time-slots", { timeSlots }),

  // ── Coaches ───────────────────────────────────────────────────────────────
  getCoaches: (params) => apiClient.get("/academy/coaches", { params }),
  createCoach: (data) => apiClient.post("/academy/coaches", data),
  updateCoach: (id, data) => apiClient.put(`/academy/coaches/${id}`, data),
  deleteCoach: (id) => apiClient.delete(`/academy/coaches/${id}`),

  // ── Batches ───────────────────────────────────────────────────────────────
  getBatches: (params) => apiClient.get("/academy/batches", { params }),
  createBatch: (data) => apiClient.post("/academy/batches", data),
  updateBatch: (id, data) => apiClient.put(`/academy/batches/${id}`, data),
  deleteBatch: (id) => apiClient.delete(`/academy/batches/${id}`),

  // ── Players ───────────────────────────────────────────────────────────────
  getPlayers: (params) => apiClient.get("/academy/players", { params }),
  createPlayer: (data) => apiClient.post("/academy/players", data),
  updatePlayer: (id, data) => apiClient.put(`/academy/players/${id}`, data),
  bulkUploadPlayers: (players) => apiClient.post("/academy/players/bulk-upload", { players }),

  // ── Attendance ────────────────────────────────────────────────────────────
  getAttendance: (params) => apiClient.get("/academy/attendance", { params }),
  bulkMarkAttendance: (data) => apiClient.post("/academy/attendance/bulk", data),

  // ── Coach Attendance ──────────────────────────────────────────────────────
  getCoachAttendance: (params) => apiClient.get("/academy/coach-attendance", { params }),
  bulkMarkCoachAttendance: (data) => apiClient.post("/academy/coach-attendance/bulk", data),

  // ── Fees ──────────────────────────────────────────────────────────────────
  getPlayerFeesDue: () => apiClient.get("/academy/fees/due"),
  recordMonthlyPayment: (data) => apiClient.post("/academy/fees/monthly-payment", data),
  getFees: (params) => apiClient.get("/academy/fees", { params }),
  recordFee: (data) => apiClient.post("/academy/fees", data),
  updateFee: (id, data) => apiClient.put(`/academy/fees/${id}`, data),
  deleteFee: (id) => apiClient.delete(`/academy/fees/${id}`),

  // ── Injuries ──────────────────────────────────────────────────────────────
  getInjuries: (params) => apiClient.get("/academy/injuries", { params }),
  createInjury: (data) => apiClient.post("/academy/injuries", data),
  updateInjury: (id, data) => apiClient.put(`/academy/injuries/${id}`, data),

  // ── Training Logs ─────────────────────────────────────────────────────────
  getTrainingLogs: (params) => apiClient.get("/academy/training-logs", { params }),
  createTrainingLog: (data) => apiClient.post("/academy/training-logs", data),
  updateTrainingLog: (id, data) => apiClient.put(`/academy/training-logs/${id}`, data),

  // ── Fee Plans ─────────────────────────────────────────────────────────────
  getFeePlans: (params) => apiClient.get("/academy/fee-plans", { params }),
  createFeePlan: (data) => apiClient.post("/academy/fee-plans", data),
  updateFeePlan: (id, data) => apiClient.put(`/academy/fee-plans/${id}`, data),
  deleteFeePlan: (id) => apiClient.delete(`/academy/fee-plans/${id}`),

  // ── License Levels ────────────────────────────────────────────────────────
  getLicenseLevels: () => apiClient.get("/academy/license-levels"),
  saveLicenseLevels: (levels) => apiClient.put("/academy/license-levels", { levels }),

  // ── Audit Logs ────────────────────────────────────────────────────────────
  getAuditLogs: (params) => apiClient.get("/academy/audit-logs", { params }),

  // ── Admission Items ───────────────────────────────────────────────────────
  getAdmissionItems: (playerId) => apiClient.get(`/academy/players/${playerId}/admission-items`),
  saveAdmissionItems: (playerId, items) => apiClient.post(`/academy/players/${playerId}/admission-items`, { playerId, items }),

  // ── Config Settings ───────────────────────────────────────────────────────
  getConfigSettings: () => apiClient.get("/academy/config-settings"),
  saveConfigSettings: (settings) => apiClient.put("/academy/config-settings", { settings }),

  // ── Expense Heads ─────────────────────────────────────────────────────────
  getExpenseHeads: (params) => apiClient.get("/academy/expense-heads", { params }),
  createExpenseHead: (data) => apiClient.post("/academy/expense-heads", data),
  updateExpenseHead: (id, data) => apiClient.put(`/academy/expense-heads/${id}`, data),
  deleteExpenseHead: (id) => apiClient.delete(`/academy/expense-heads/${id}`),

  // ── Expenses ──────────────────────────────────────────────────────────────
  getExpenses: (params) => apiClient.get("/academy/expenses", { params }),
  createExpense: (data) => apiClient.post("/academy/expenses", data),
  updateExpense: (id, data) => apiClient.put(`/academy/expenses/${id}`, data),
  deleteExpense: (id) => apiClient.delete(`/academy/expenses/${id}`),
  getExpenseReport: (params) => apiClient.get("/academy/expense-report", { params }),
};
